import MenuLogo from './MenuLogo'

export default MenuLogo
